// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from './store'
import Notifications from 'vue-notification'
import Vuelidate from 'vuelidate'
import http from "./shared/http"
import mediaHttp from "./shared/mediaHttp"
import transactionApi from "./shared/transactionApi"
import integrationsApi from "./shared/integrationsApi"
import workflowApi from "./shared/workflowApi"
import ratchetApi from "./shared/ratchetApi"
import {can, isAdmin, isProjectOwner, toUserTimeZone, debugLog, loaderPopup, isPlatformEnv, translateLabel, pageUnavailable, deleteConfirmationPrompt} from "./shared/utils"
import {setupComponents} from "./shared/components"
import {errorModal} from "./shared/serverErrorModal"
import ScrollLoader from 'vue-scroll-loader'
import Tawk from './components/tawk'
import VueGtag from "vue-gtag";
import './registerServiceWorker'
import VueScreen from 'vue-screen';
import VModal from 'vue-js-modal'
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-select/dist/vue-select.css';
import TreeView from "vue-json-tree-view"
import i18n from './translation'
import protokol from './plugins/protokol'
import tutorials from './plugins/protokol/components/tutorials.js'
import ProtokolMixins from './plugins/protokol/mixins.js'

import "bootstrap-icons/font/bootstrap-icons.css";

Vue.use(BootstrapVue, {
  BvModal: { headerBgVariant: 'dark', footerBgVariant: 'dark', bodyBgVariant: 'dark', centered: true },
  BModal: { headerBgVariant: 'dark', footerBgVariant: 'dark', bodyBgVariant: 'dark', centered: true },
  BSidebar: { bgVariant: 'dark', textVariant: 'light' },
  BDropdown: { variant: 'dark' }
})
Vue.use(BootstrapVueIcons)
Vue.use(Notifications)
Vue.use(Vuelidate)
Vue.use(ScrollLoader)
Vue.use(VueScreen, 'bootstrap')
Vue.use(VModal)
Vue.use(Loading)
Vue.use(TreeView)

Vue.mixin(ProtokolMixins)

Vue.prototype.$http = http
Vue.prototype.$mediaHttp = mediaHttp
Vue.prototype.$transactionApi = transactionApi
Vue.prototype.$integrationApi = integrationsApi
Vue.prototype.$workflowApi = workflowApi
Vue.prototype.$ratchetApi = ratchetApi
Vue.prototype.$can = can
Vue.prototype.$isAdmin = isAdmin
Vue.prototype.$toUserTimeZone = toUserTimeZone
Vue.prototype.$isProjectOwner = isProjectOwner
Vue.prototype.$serverErrorModal = errorModal
Vue.prototype.$setupComponents = setupComponents
Vue.prototype.$debugLog = debugLog
Vue.prototype.$loadingPopup = loaderPopup
Vue.prototype.$isPlatformEnv = isPlatformEnv
Vue.prototype.$translateLabel = translateLabel
Vue.prototype.$pageUnavailable = pageUnavailable
Vue.prototype.$deleteConfirmationPrompt = deleteConfirmationPrompt

const pageHref = window.location.search
const searchParams = new URLSearchParams(pageHref);
const lang = searchParams.get('lang')

if (lang) {
  i18n.locale = lang
  localStorage.setItem('locale', lang)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: {
    App
  },

  created() {
    console
    Vue.use(protokol, {
      tutorials
    })

    Vue.use(VueGtag, {
      enabled: this.$env.get('MODE') == 'production',
      config: { id: this.$env.get("GTAG") }
    }, router);

    if (this.$env.get('MODE') == 'production') {
      Vue.use(Tawk, {
        tawkSrc: this.$env.get('TAWK_SRC')
      })
    } else if (this.$env.get('MODE') == 'staging') {
      console.log("Application running with config:", this.$env.getAll())
    } else {
      console.log("Application running with config:", this.$env.getAll())
    }
  }
})